import { Image } from 'ui/atoms/Image';
import { InfiniteScroller } from 'ui/molecules/InfiniteScroller/InfiniteScroller';

import styles from './EnrichmentTrustBar.module.scss';

const LOGOS = ['lseg', 'experian', 'sap', 'kroll', 'uber', 'schneider', 'allianz', 'jp-morgan'];

const logoElements = LOGOS.map((logo) => (
  <div key={logo} className={styles.logo}>
    <Image width={110} height={28} src={`img/customers/${logo}.svg`} alt={`${logo} logo`} />
  </div>
));

export const EnrichmentTrustBar = () => (
  <div
    className={styles.root}
    aria-label="Trusted by teams at LSEG, Experian, SAP, Kroll, Uber, Schneider Electric, Allianz, JP Morgan"
  >
    <span className={styles.label}>Trusted by teams at</span>
    <InfiniteScroller
      className={styles.scroller}
      items={logoElements}
      slideWidth={120}
      slideGap={12}
      animationDuration={26}
      backgroundColor="#F3F8FF"
    />
  </div>
);
